import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { PhrasesSelectorRefinementsContainer } from '../../../containers/PhrasesSelectorRefinementsContainer/PhrasesSelectorRefinementsContainer';
import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../../typings/phrases';
import { ScopedPopup } from '../../ScopedPopup/ScopedPopup';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';

import './PhrasesSelectorRefinePopup.css';

export interface PhraseSelectorRefinePopupProps {
    keyword: PhrasesSelectorPhrase;
    anchorBlockName: string;
    wizardId: PhrasesSelectorWizardId;
    onRefine: (phrase: PhrasesSelectorPhrase) => void;
    onRefinePopupOpenMetrica: () => void;
}

interface PhrasesSelectorRefineState {
    isOpen: boolean;
}

const BLOCK = 'phrases-selector-refine-popup';

export class PhrasesSelectorRefinePopup extends React.PureComponent<
    PhraseSelectorRefinePopupProps,
    PhrasesSelectorRefineState
> {
    state = {
        isOpen: false
    };

    render() {
        const { isOpen } = this.state;
        const {
            keyword: { name, shows },
            anchorBlockName,
            wizardId
        } = this.props;

        return (
            <>
                <ScopedPopup
                    secondaryOffset={-11}
                    cls={BLOCK}
                    hiding={true}
                    theme="normal"
                    anchor={this}
                    visible={isOpen}
                    target="anchor"
                    onClose={this.onToggle}
                    onOutsideClick={this.onToggle}
                >
                    <PhrasesSelectorRefinementsContainer
                        keyword={name}
                        shows={shows}
                        wizardId={wizardId}
                        onCancel={this.onToggle}
                        onRefine={this.onRefine}
                    />
                </ScopedPopup>
                <span
                    className={classNames(
                        Bem.cls(anchorBlockName, 'phrase-name'),
                        TestBem.cls(anchorBlockName, 'phrase-name')
                    )}
                    title={name}
                >
                    {name}
                </span>
                <Button
                    theme="clear"
                    size="s"
                    cls={classNames(
                        Bem.cls(anchorBlockName, 'icon-button', {
                            action: 'edit'
                        }),
                        TestBem.cls(anchorBlockName, 'edit-btn')
                    )}
                    onClick={this.onToggle}
                >
                    <Shape2 width={14} height={14} icon={Shape2Icon.edit} />
                </Button>
            </>
        );
    }

    private onToggle = () => {
        const { onRefinePopupOpenMetrica } = this.props;

        if (!this.state.isOpen) {
            onRefinePopupOpenMetrica();
        }

        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };

    private onRefine = (phrase: PhrasesSelectorPhrase) => {
        this.props.onRefine(phrase);

        this.onToggle();
    };
}
